import React, { useState } from "react";
import { observer } from "mobx-react";
import CustomTooltip from "Components/common/CustomTooltip";
import Utils from "Utils/utils";

const waMetricsObj = [
  {
    name: "messageSentCount",
    id: "messageSentCount",
    icon: <i className="material-icons" style={{ fontSize: "18px", color: "#25D366" }}>send</i>,
    tooltipText: "Messages Sent"
  },
  {
    name: "messageReceivedCount",
    id: "messageReceivedCount",
    icon: <i className="material-icons" style={{ fontSize: "18px", color: "#555" }}>reply</i>,
    tooltipText: "Replies Received"
  }
];

const WhatsAppMetrics = observer(props => {
  const [tooltipIndex, setTooltipIndex] = useState("");

  return (
    <div className="linkedInMetricsWrapper">
      {waMetricsObj.map((item, index) => {
        const { id = "", icon = <></>, tooltipText = "" } = item || {};
        return (
          <div
            className="metrics"
            key={id}
            onMouseOver={() => setTooltipIndex(index)}
            onMouseLeave={() => setTooltipIndex("")}
          >
            <div className="metricsIcon">{icon}</div>
            <div className="metricsValue">
              {Utils.formatNumberToStringInUSFormat(props?.[id]) || 0}
            </div>
            {index === tooltipIndex && <CustomTooltip text={tooltipText} />}
          </div>
        );
      })}
    </div>
  );
});

export { WhatsAppMetrics };
export default WhatsAppMetrics;
